import { render, staticRenderFns } from "./BotProfile.vue?vue&type=template&id=7e65169a&scoped=true&"
import script from "./BotProfile.vue?vue&type=script&lang=js&"
export * from "./BotProfile.vue?vue&type=script&lang=js&"
import style0 from "./BotProfile.vue?vue&type=style&index=0&id=7e65169a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e65169a",
  null
  
)

export default component.exports